
import { Options, Vue } from "vue-class-component"
// import { State, Action, Getter } from "vuex-class";
document.documentElement.className = 'theme-dark'
@Options({})
export default class App extends Vue {}
